import { ILibraryTopology } from '../registry.types';

export const REGISTRY_LIBRARY_PREFIX_DEPRECATED =
  'components-registry-library-';
export const SHORT_REGISTRY_LIBRARY_PREFIX = '_rb-';

export const URL_NAMESPACE_SEPARATOR = '~';

export const whitelistedEndpoints = [
  'https://bo.wix.com/suricate/tunnel/',
  'https://localhost:',
  'http://localhost:',
  'https://sled.wix.dev/',
  'https://static.parastorage.com/',
];

const isAllowedHostRegexp = new RegExp(
  `^((${whitelistedEndpoints.join(')|(')}))`,
);

export const getComponentsLibrariesFromURL = (
  url: string,
  prefix: string = SHORT_REGISTRY_LIBRARY_PREFIX,
): Array<ILibraryTopology> => {
  if (!url || typeof URLSearchParams === 'undefined') {
    return [];
  }

  const search = url.split('?').pop();

  if (!search) {
    return [];
  }

  const libraries: Array<ILibraryTopology> = [];

  const params = new URLSearchParams(search);

  params.forEach((value, key) => {
    if (
      key.startsWith(REGISTRY_LIBRARY_PREFIX_DEPRECATED) ||
      key.startsWith(prefix)
    ) {
      const withDeprecatedPrefix = key.includes(
        REGISTRY_LIBRARY_PREFIX_DEPRECATED,
      );

      const artifactId = key
        .split(
          withDeprecatedPrefix ? REGISTRY_LIBRARY_PREFIX_DEPRECATED : prefix,
        )
        .pop();

      const [libraryUrl, manifestNameOrNamespace] = value.split(
        URL_NAMESPACE_SEPARATOR,
      );

      if (!isAllowedHostRegexp.test(libraryUrl)) {
        return;
      }

      if (artifactId) {
        libraries.push({
          artifactId,
          url: libraryUrl,
          namespace: manifestNameOrNamespace,
        });
      }
    }
  });

  return libraries;
};
